import React, { useEffect, useState } from "react";
import "./PointCalculation.scss";
import { withTranslation, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../src/components/Header/Header";
import RulesListAuto from "./Auto/RulesList";
import PointsManualAdjust from "../PointAdjustment/PointsManualAdjust";
import RulesListManual from "./Manual/RulesList";
import { Tab, Tabs } from "@material-ui/core";
import { ToastContainer, toast } from 'react-toastify';
import { isPermission, authorizedMessage } from "../../../_helpers/commonAPI";
import AuthorizedMessagePage from "../../../components/AuthorizedMessagePage";

function Main(props) {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const [isHideComponent, setIsHideComponent] = useState(false)

  const handleChange = async (event, newValue) => {
    // if (newValue === 2) {
    //   const isAllow = await isPermission("LoyaltyPointCalculation-PointAdjustManual-view")
    //   if (!isAllow) {
    //     toast.success(authorizedMessage, {
    //       position: toast.POSITION.TOP_RIGHT
    //     });
    //     return 0;
    //   }
    // }
    // if (newValue === 0 || newValue === 1) {
    //   const isAllow = await isPermission("LoyaltyPointCalculation-PointCalculationRules-view")
    //   if (!isAllow) {
    //     toast.success(authorizedMessage, {
    //       position: toast.POSITION.TOP_RIGHT
    //     });
    //     return 0;
    //   }
    // }
    setSelectedTab(newValue);
  };

  // useEffect(async()=>{
  //   const isAllow = await isPermission("LoyaltyPointCalculation-PointCalculationRules-view")
  //   setIsHideComponent(isAllow)
  // },[])


  return (
    <>
      <div className="content-wrapper">
        <Header title="Point Calculation Rules " />
        <div className="row ipad_css ">
          <div className="mainScroll">
            <div className="col-12 mt-2">
              <Tabs value={selectedTab} onChange={handleChange}>
                <Tab label="POINTS CALCULATION RULES - AUTO" wrapped={false} style={{ maxWidth: "295px" }} />
                <Tab label="POINTS CALCULATION RULES - MANUAL" wrapped={false} style={{ maxWidth: "312px" }} />
                <Tab label="POINTS ADJUST - MANUAL" wrapped={false} style={{ maxWidth: "312px" }} />
              </Tabs>
              {selectedTab === 0 && <RulesListAuto />}
              {selectedTab === 2 && <PointsManualAdjust />}
              {selectedTab === 1 && <RulesListManual />}
              {/* coming soon */}
              {/* <SubDealerList /> */}
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}

export default withTranslation()(Main);
